// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loaderWrapper--DFsPr","transparent":"transparent--kebOV"};